import * as React from "react";
import { Query, graphql } from "react-apollo";
import { Row, Col, Button } from "reactstrap";
import * as uuid from "uuid";
import { MdModeEdit, MdDeleteForever } from "react-icons/md";

// GraphQL
import GetCompanyCustomers from "../../GraphQL/Queries/GetCompanyCustomers";
import DeleteCustomer from "../../GraphQL/Mutations/DeleteCustomer";

// Presentation/UI
import Loader from "../../Components/Loader/DotLoader";
import Table from "../../Components/Table";
import GlobalModal from "../../Components/GlobalModal";
import DialogModal from "../../Components/DialogModal";

import EditCustomerForm from "./EditCustomerForm";

interface IProps {
  companyId: string;
  toastManager: any;
  mutate: any;
}

class AllCustomers extends React.Component<IProps> {
  state = {
    modal: false,
    dialogModal: false,
    loading: false,
    title: "Are you sure you want to delete this customer?",
    customer: {},
    customerId: null
  };

  // Close dialog modal
  closeDialogModal = (): void => {
    this.setState({
      dialogModal: false
    });
  };

  // Open dialog modal
  openDialogModal = (companyCustomer: any): void => {
    const customerId = !companyCustomer ? null : companyCustomer.id;
    this.setState({
      dialogModal: true,
      customerId
    });
  };

  // Handle response
  handleResponse = (e: React.FormEvent<HTMLInputElement>): void => {
    e.preventDefault();
    this.setState({ loading: true });
    // delete site mutation
    const { companyId } = this.props;
    this.props
      .mutate({
        variables: {
          id: this.state.customerId
        },
        refetchQueries: [
          {
            query: GetCompanyCustomers,
            variables: { id: companyId }
          }
        ]
      })
      .then((res: any) => {
        this.setState({ loading: false, siteId: null });
        this.closeDialogModal();
        this.toastNotification("Customer deleted successfully");
      })
      .catch((err: any) => {
        console.log(err);
      });
  };

  // Close modal
  closeModal = (): void => {
    this.setState({
      modal: false
    });
  };

  // Open modal
  openModal = (customer: object): void => {
    this.setState({
      modal: true,
      customer
    });
  };

  // success notification
  toastNotification = (message: string) => {
    this.props.toastManager.add(message, {
      appearance: "success",
      autoDismiss: true
    });
  };

  render() {
    const { customer } = this.state;
    const { companyId } = this.props;
    return (
      <Query query={GetCompanyCustomers} variables={{ id: companyId }}>
        {({ loading, error, data }) => {
          if (loading) {
            return <Loader />;
          }
          if (error) {
            return <div>There was a problem loading the data</div>;
          }

          const customers = data.allCustomers;

          return (
            <Row>
              <GlobalModal
                toggleModal={this.closeModal}
                title="Edit Customer"
                modalDisplay={
                  <EditCustomerForm
                    notification={this.toastNotification}
                    closeModal={this.closeModal}
                    companyId={companyId}
                    customer={customer}
                  />
                }
                modal={this.state.modal}
              />
              <DialogModal
                modal={this.state.dialogModal}
                title={this.state.title}
                loading={this.state.loading}
                toggleModal={this.closeDialogModal}
                handleResponse={this.handleResponse}
              />
              <Col xs={12} md={12} lg={12}>
                <Table
                  data={customers}
                  columns={[
                    {
                      Header: "Name",
                      accessor: "name",
                      sortable: false,
                      filterable: false
                    },
                    {
                      Header: "Physical Address",
                      accessor: "address",
                      sortable: false,
                      filterable: false
                    },
                    {
                      Header: "Email",
                      accessor: "email",
                      sortable: false,
                      filterable: false
                    },
                    {
                      Header: "Phone Number",
                      accessor: "phoneNumber",
                      sortable: false,
                      filterable: false
                    },
                    {
                      Header: "Customer Request Code",
                      accessor: "customerRequestCode",
                      sortable: false,
                      filterable: false
                    },
                    {
                      id: uuid(),
                      Header: "",
                      accessor: (companyCustomer: object) => {
                        return (
                          <Button
                            onClick={() => this.openModal(companyCustomer)}
                            className="icon-btn icon-edit-btn"
                          >
                            <MdModeEdit color="#fff" size="1.35em" />
                          </Button>
                        );
                      },
                      sortable: false,
                      filterable: false
                    },
                    {
                      id: uuid(),
                      Header: "",
                      accessor: (companyCustomer: object) => {
                        return (
                          <Button
                            onClick={() =>
                              this.openDialogModal(companyCustomer)
                            }
                            className="icon-btn icon-delete-btn"
                          >
                            <MdDeleteForever color="#fff" size="1.35em" />
                          </Button>
                        );
                      },
                      sortable: false,
                      filterable: false
                    }
                  ]}
                  defaultPageSize={5}
                  showPaginationTop={false}
                  showPaginationBottom={true}
                />
              </Col>
            </Row>
          );
        }}
      </Query>
    );
  }
}

export default graphql<any, Response, any, any>(DeleteCustomer)(AllCustomers);



// WEBPACK FOOTER //
// ./src/Containers/Customers/AllCustomers.tsx